import InputSelect from "components/common/InputSelect";
import InputSelectMultipleAutocomplete from "components/common/InputSelectMultipleAutocomplete";
import InputText from "components/common/InputText";
import { Formik } from "formik";
import React, { FC, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { Toggle } from "rsuite";
import { addMachineInCurrentInspection } from "services/inspectorRequest";
import { getMachineList } from "services/userService";
import { inspect } from "util";
import { AddMachineSchema } from "validations/InspectionRequest";
import * as Yup from "yup";
const AddNewMachine: FC<any> = ({
  showMachine,
  handleShowMachineClose,
  inspectionType,
  user_id,
  inspection_id,
  setIsMutation,
}) => {
  const [existingMachine, setExistingMachine] = React.useState(false);
  const initialValuesMachine = {
    device_id: "",
    make: "",
    model_number: "",
    serial_number: "",
    inspection_type: "",
    machine_inspect: null,
    machine_id: null,
  };
  const addMachineSubmitForm = (values: any, actions: any) => {
    addMachinInProgressInspection(values);
  };
  const addMachinInProgressInspection = (values: any) => {
    const formatedData = {
      device_id: values.device_id,
      make: values.make,
      model_number: values.model_number,
      serial_number: values.serial_number,
      inspection_type: values.inspection_type,
      user_id: user_id,
      inspection_id: inspection_id,
      machine_id: values.machine_id,
    };
    console.log("formatedData", formatedData);
    addMachineInCurrentInspection(formatedData)
      .then((response) => {
        console.log("response", response);
        toast.success(response.message);
        setIsMutation((prevState) => !prevState);
        handleShowMachineClose();
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };
  const [machines, setMachines] = useState<any>([]);
  const [machineList, setMachineList] = useState<any>([]);
  const [selectMachines, setSelectMachines] = useState<any>([]);

  useEffect(() => {
   // if (existingMachine) {
      getUserMachineData(user_id);
    //}
  }, []);
  const validateExistingMachine = Yup.object().shape({
    machine_inspect: Yup.string()
      .required("Machine to inspect is required")
      .typeError("Machine to inspect is required"),
    inspection_type: Yup.string().required().max(255).label("Inspection Type"),
  });

  const manipulateValue = (obj: any) => {
    return (
      (obj.make ? obj.make : "-") +
      "(" +
      (obj.device_id ? obj.device_id : "-") +
      "/" +
      (obj.model_number ? obj.model_number : "-") +
      "/" +
      (obj.serial_number ? obj.serial_number : "-") +
      ")"
    );
  };

  const getUserMachineData = async (userId) => {
    await getMachineList({ userId })
      .then(async (response) => {
        setMachines(response.data);

        const newData = await Promise.all(
          response.data.map(async (obj: any) => {
            const manipulatedValue = await manipulateValue(obj);
            return { key: obj.id, value: manipulatedValue };
          })
        );

        const uniqueArray = await Promise.all(
          Array.from(new Set(newData.map((a) => a.value.toLowerCase()))).map(
            (value) => {
              return newData.find(
                (a) => a.value.toLowerCase() === value.toLowerCase()
              );
            }
          )
        );

        setMachineList(uniqueArray);
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      });
  };
  const addExistingMachine = (e, setFieldValue) => {
    const machineData = machines.find((obj) => obj.id === e.target.value);
    setFieldValue("device_id", machineData.device_id);
    setFieldValue("make", machineData.make);
    setFieldValue("model_number", machineData.model_number);
    setFieldValue("serial_number", machineData.serial_number);
    setFieldValue("machine_id", machineData.id);
  };
  return (
    <div>
      <Modal
        show={showMachine}
        onHide={handleShowMachineClose}
        centered
        dialogClassName="modal-350w"
      >
        <Modal.Header
          closeButton
          className="border-0 pb-0 d-flex justify-content-between"
        >
          <Modal.Title className="fs-25 fw-bold">
            <div>Add Machine</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validationSchema={
              existingMachine ? validateExistingMachine : AddMachineSchema
            }
            initialValues={initialValuesMachine}
            onSubmit={(values, actions) => {
              actions.setSubmitting(false);
              addMachineSubmitForm(values, actions);
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              setFieldValue,
            }) => (
              <>
                <div className="mb-3">
                  {machineList.length > 0 ? (
                    <>
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          setExistingMachine(e.target.checked);
                        }}
                        id="existingMachine"
                      />
                      <label className="ms-2" htmlFor="existingMachine">
                        Existing Machine
                      </label>
                    </>
                  ):null}
                </div>

                <Form className="text-start" noValidate onSubmit={handleSubmit}>
                  <>
                    {existingMachine && (
                      <>
                        <label>Machine to inspect</label>
                        {/* <InputSelectMultipleAutocomplete
                          controlId="machine_inspect"
                          label=""
                          placeholder=""
                          handleBlur={handleBlur}
                          handleChange={handleChange}
                          selected={selectMachines}
                          setValue={setSelectMachines}
                          options={machineList}
                        />
                        {selectMachines.length === 0 && (
                          <div className="text-danger">
                            Machine to inspect is required
                          </div>
                        )} */}
                        <InputSelect
                          controlId="machine_inspect"
                          label=""
                          placeholder="Select Existing Machine"
                          touched={touched.machine_inspect}
                          handleBlur={handleBlur}
                          handleChange={(e) => {
                            handleChange(e);
                            addExistingMachine(e, setFieldValue);
                          }}
                          errorsField={errors.machine_inspect}
                          value={values.machine_inspect}
                          options={machineList}
                        />
                      </>
                    )}
                    <InputText
                      controlId="device_id"
                      label="Device ID"
                      placeholder="Device ID"
                      touched={touched.device_id}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      errorsField={errors.device_id}
                      disabled={existingMachine}
                      value={values.device_id}
                    />
                    <InputText
                      controlId="make"
                      label="Make"
                      placeholder="Make"
                      touched={touched.make}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      errorsField={errors.make}
                      disabled={existingMachine}
                      value={values.make}
                    />
                    <InputText
                      controlId="model_number"
                      label="Model no."
                      placeholder="Model no."
                      touched={touched.model_number}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      errorsField={errors.model_number}
                      disabled={existingMachine}
                      value={values.model_number}
                    />
                    <InputText
                      controlId="serial_number"
                      label="Serial no."
                      placeholder="Serial no."
                      touched={touched.serial_number}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      errorsField={errors.serial_number}
                      disabled={existingMachine}
                      value={values.serial_number}
                    />
                    <InputSelect
                      controlId="inspection_type"
                      label="Inspection Type"
                      placeholder="Inspection Type"
                      touched={touched.inspection_type}
                      handleBlur={handleBlur}
                      handleChange={handleChange}
                      errorsField={errors.inspection_type}
                      value={values.inspection_type}
                      options={inspectionType}
                    />
                  </>

                  <div className="d-flex justify-content-end">
                    <Button
                      variant="outline-secondary"
                      className="me-2 fs-15 fw-semibold text-black"
                      onClick={handleShowMachineClose}
                    >
                      Close
                    </Button>
                    <Button
                      variant="primary"
                      className="fs-15 fw-semibold text-black"
                      type="submit"
                    >
                      Submit
                    </Button>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AddNewMachine;
